import React from 'react'
import { GET_MERCHANT_INTEGRATIONS } from 'components/Integrations/queries'
import { MerchantIntegrationSettings } from 'components/Integrations/types'
import { useIntegration } from 'hooks/useGlobalContext/useIntegration'
import { LoaderProps } from './types'
import { useFetchOnce } from './useFetchOnce'

// Merchant-wide (which partners are connected), read by both ManageLeat and
// ManageLightspeed — shared GraphQL data, so Loader/Context per
// doc/ARCHITECTURE.md §6.
export const MerchantIntegrationsLoader = ({
  isParentLoaded = true,
  children
}: LoaderProps) => {
  const {
    merchantIntegrations,
    setMerchantIntegrations,
    setRefetchMerchantIntegrations
  } = useIntegration()

  const { isLoaded } = useFetchOnce<{
    getMerchantIntegrations: MerchantIntegrationSettings
  }>({
    query: GET_MERCHANT_INTEGRATIONS,
    skip: merchantIntegrations !== null,
    onData: (data) => {
      if (data.getMerchantIntegrations) {
        setMerchantIntegrations(data.getMerchantIntegrations)
      }
    },
    onRefetch: (refetch) => {
      const refetchAndSync = async () => {
        const result = (await refetch()) as {
          data?: { getMerchantIntegrations: MerchantIntegrationSettings }
        }
        if (result.data?.getMerchantIntegrations) {
          setMerchantIntegrations(result.data.getMerchantIntegrations)
        }
        return result
      }

      setRefetchMerchantIntegrations(
        (() => refetchAndSync) as unknown as () => Promise<unknown>
      )
    },
    isParentLoaded
  })

  return <React.Fragment>{children(isLoaded)}</React.Fragment>
}
